/**
 * Product Group functionality
 */
function cdProductGroupBlock() {(function($) {
	$(document).ready(function() {
		$('.wp-block-cd-product-group.slider .inner-blocks').slick({
			//centerMode: true,
			slidesToShow: 1,
			arrows: true,
			infinite: true,
		});
	});
}(jQuery));}
cdProductGroupBlock();